// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1eE8R","innerimg":"Card_innerimg__2CEpR","details":"Card_details__25VEl","favIconRed":"Card_favIconRed__3V9A2"};